var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.hasTextButton ? _c('MdmLink', {
    staticClass: "btn",
    class: [_vm.sizes[_vm.size], _vm.types[_vm.type]],
    attrs: {
      "url": _vm.url,
      "is-scramble-link": _vm.isScrambleLink,
      "target": _vm.targetAttribute
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm.svg ? _c('mdm-icon', {
    staticClass: "icon",
    class: _vm.svg,
    attrs: {
      "name": _vm.svg,
      "size": "16"
    }
  }) : _vm._e(), _vm._v("\n  " + _vm._s(_vm.textBtn) + "\n")], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };